import { EventEmitter, Injectable, Output } from '@angular/core';
import { RestResponse } from 'app/modules/common/entities/rest.response.model';
import { ApiService } from 'app/modules/common/services/api.service';
import { BehaviorSubject, Observable } from 'rxjs';
import API from '../../../modules/common/services/api.config.json';

@Injectable({
  providedIn: 'root'
})
export class StaffImportViewService {

  selectedCamposImportacionList: BehaviorSubject<any> = new BehaviorSubject([]);  
  @Output() isSaveExcelImportTemplate = new EventEmitter<any>();
  
}
